export const ACTIVITY_MENU_LABELS = {
  'new-order': 'Новый заказ',
  'my-orders': 'Мои заказы',
  tasks: 'Поручения',
  'orders-log': 'Журнал заказов',
  routes: 'Маршруты',
  expenses: 'Расходы',
  statistics: 'Статистика',
  management: 'Управление',
  news: 'Новости',
  settings: 'Настройки',
};

export const ACTIVITY_VALUE_LABELS = {
  active: 'Активен',
  inactive: 'Неактивен',
  blocked: 'Заблокирован',
  deleted: 'Удален',
  draft: 'Черновик',
  scheduled: 'Запланировано',
  expired: 'Истекло',
  archived: 'В архиве',
  restored: 'Восстановлен',
  enabled: 'Включено',
  disabled: 'Выключено',
  open: 'Открыто',
  closed: 'Закрыто',
  admin: 'Администратор',
  developer: 'Разработчик',
  dispatcher: 'Диспетчер',
  manager: 'Менеджер',
  operator: 'Оператор',
  employee: 'Сотрудник',
  courier: 'Курьер',
  user: 'Пользователь',
  b2c: 'Физлица',
  b2b: 'Юрлица',
  all: 'Все',
  news: 'Новость',
  instruction: 'Инструкция',
  laundry: 'Прачечная',
  cleaning: 'Химчистка',
  washing: 'Стирка',
  auto_item_flow: 'Автоматически по потоку предмета',
  washing_laundry: 'Прачечная',
  washing_cleaning: 'Чистка',
  pickup: 'Забор',
  delivery: 'Доставка',
  handover: 'Выдача',
  approval: 'Согласование',
  drying_packing: 'Сушка и упаковка',
  pending: 'Ожидает',
  in_progress: 'В работе',
  completed: 'Завершено',
  cancelled: 'Отменено',
  canceled: 'Отменено',
  rejected: 'Отклонено',
  approved: 'Подтверждено',
  skipped: 'Пропущено',
  available: 'Доступно',
  assigned: 'Назначено',
  rework: 'На доработку',
  unassigned: 'Не назначено',
  deferred: 'Отложено',
  client_unavailable: 'Клиент недоступен',
  client_rescheduled: 'Клиент попросил перенести',
  access_problem: 'Нет доступа к адресу',
  technical_problem: 'Техническая проблема',
  company: 'Компания',
  individual: 'Физлицо',
  company_bank: 'Расчетный счет',
  employee_wallet: 'Кошелек сотрудника',
  cash: 'Наличные',
  bank: 'Банк',
  email: 'Электронная почта',
  paper: 'Бумажный',
  self_pickup: 'Самовывоз',
  self_delivery: 'Без выезда',
  all_filtered: 'Все подходящие записи',
  current_page: 'Текущая страница',
  xlsx: 'Excel',
  docx: 'Word',
  deferred_orders: 'Отложенные заказы',
  today_unassigned: 'Сегодня без исполнителя',
  today_overdue: 'Просрочено сегодня',
  stage_stale: 'Долго без движения на этапе',
  order_old: 'Старый активный заказ',
  active_rework: 'Активная доработка',
  active_revision: 'Активный повтор',
  normal: 'Обычный',
  urgent: 'Срочный',
  high: 'Высокий',
  low: 'Низкий',
  rub: 'Рубли',
  percent: 'Проценты',
  info: 'Информационное',
  warning: 'Предупреждение',
  error: 'Ошибка',
  success: 'Успешно',
  paid: 'Оплачено',
  unpaid: 'Не оплачено',
  partially_paid: 'Оплачено частично',
  true: 'Да',
  false: 'Нет',
  null: 'Не указано',
  none: 'Не указано',
  dadata_api_token: 'Токен DaData',
  yandex_maps_api_key: 'Ключ Яндекс Карт',
  yandex_geocoder_api_key: 'Ключ Яндекс Геокодера',
  timezone: 'Часовой пояс',
  order_start_number: 'Стартовый номер заказов',
  expense_auto_approve_limit: 'Лимит автоматического подтверждения расходов',
  company_name: 'Краткое название компании',
  company_full_name: 'Полное название компании',
  company_legal_address: 'Юридический адрес компании',
  company_inn: 'ИНН компании',
  company_kpp: 'КПП компании',
  company_ogrn: 'ОГРН компании',
  company_bank_name: 'Банк компании',
  company_bank_account: 'Расчетный счет компании',
  company_bank_corr_account: 'Корреспондентский счет компании',
  company_bank_bik: 'БИК банка компании',
  company_phone: 'Телефон компании',
  company_email: 'Электронная почта компании',
  invoice_start_number: 'Стартовый номер счетов',
  invoice_payment_terms_days: 'Срок оплаты счета',
  smtp_host: 'Сервер отправки почты',
  smtp_port: 'Порт сервера отправки почты',
  smtp_username: 'Логин сервера отправки почты',
  smtp_password: 'Пароль сервера отправки почты',
  smtp_use_tls: 'Защищенное соединение с почтовым сервером',
  smtp_use_ssl: 'Шифрование соединения с почтовым сервером',
  smtp_from_email: 'Адрес отправителя счетов',
  smtp_from_name: 'Имя отправителя счетов',
  user_agreement_title: 'Заголовок пользовательского соглашения',
  user_agreement_subtitle: 'Подзаголовок пользовательского соглашения',
  user_agreement_content: 'Текст пользовательского соглашения',
  user_agreement_version: 'Версия пользовательского соглашения',
  cleaning_storage_cells_required: 'Обязательное указание ячейки для потока «Чистка»',
};

export const ACTIVITY_FIELD_LABELS = {
  id: 'Идентификатор',
  user_id: 'Пользователь',
  target_user_id: 'Пользователь',
  login: 'Логин',
  target_login: 'Логин',
  target_user_login: 'Пользователь',
  target_user_name: 'Кому',
  target_ip: 'IP-адрес',
  failed_attempts: 'Неудачные попытки входа',
  locked_until: 'Заблокирован до',
  user_name: 'Пользователь',
  first_name: 'Имя',
  last_name: 'Фамилия',
  middle_name: 'Отчество',
  company_name: 'Компания',
  full_name: 'Полное имя',
  phone: 'Телефон',
  email: 'Электронная почта',
  user_type: 'Роль',
  user_status: 'Статус',
  user_roles: 'Этапы',
  available_menus: 'Разделы меню',
  departments: 'Подразделения',
  department_ids: 'Подразделения',
  department_id: 'Подразделение',
  department_name: 'Подразделение',
  previous_department: 'Предыдущее подразделение',
  new_department: 'Новое подразделение',
  block_reason: 'Причина блокировки',
  reason: 'Причина',
  is_hidden: 'Скрытый профиль',
  works_with_tasks: 'Поручения',
  active: 'Активность',
  is_active: 'Активность',
    vip: 'Особый клиент',
    undesirable: 'Нежелательный клиент',
  title: 'Заголовок',
  name: 'Название',
  category: 'Категория',
  target_summary: 'Показывается',
  title_image_url: 'Изображение',
  content_preview: 'Текст',
  content: 'Содержимое',
  description: 'Описание',
  text: 'Описание',
  comment: 'Комментарий',
  note: 'Заметка',
  notes: 'Заметки',
  internal_notes: 'Внутренняя заметка',
  key: 'Настройка',
  value: 'Значение',
  old_value: 'Предыдущее значение',
  new_value: 'Новое значение',
  old_status: 'Предыдущий статус',
  new_status: 'Новый статус',
  previous_status: 'Предыдущий статус',
  status: 'Статус',
  order_status: 'Статус заказа',
  stage_status: 'Статус этапа',
  stage: 'Этап',
  stage_id: 'Этап',
  stage_label: 'Этап',
  stage_name: 'Этап',
  order_id: 'Заказ',
  order_number: 'Номер заказа',
  task_id: 'Поручение',
  task_number: 'Номер поручения',
  item_id: 'Предмет заказа',
  item_number: 'Номер предмета',
  item_name: 'Предмет заказа',
  storage_cell_id: 'Ячейка',
  storage_cell_name: 'Название ячейки',
  items: 'Позиции',
  items_count: 'Количество позиций',
  completed_count: 'Выполнено предметов',
  cycle: 'Номер повтора',
  rows_count: 'Строк в документе',
  service_id: 'Услуга',
  service_name: 'Услуга',
  service_type: 'Тип услуги',
  service_group_id: 'Группа услуг',
  group_id: 'Группа',
  group_name: 'Группа',
  client_id: 'Клиент',
  client_name: 'Клиент',
  client_type: 'Тип клиента',
  client_kind: 'Тип клиентов',
  export_format: 'Формат файла',
  export_scope: 'Объем выгрузки',
  exported_count: 'Выгружено записей',
  fields: 'Поля выгрузки',
  apply_filters: 'Применены фильтры',
  processing_route: 'Маршрут обработки',
  execution_credit_stage: 'Кому засчитывать выполнение',
  execution_credit_stage_snapshot: 'Этап выполнения допуслуги',
  unit: 'Единица измерения',
  unit_type: 'Тип цены',
  requires_approval: 'Нужно подтверждение',
  assignee_id: 'Исполнитель',
  assignee_name: 'Исполнитель',
  assigned_to: 'Исполнитель',
  assigned_to_name: 'Исполнитель',
  previous_assigned_to: 'Предыдущий исполнитель',
  is_deferred: 'Отложено',
  deferred_event_id: 'Отложенное задание',
  deferred_resolution: 'Решение по отложенному заданию',
  reason_code: 'Категория причины',
  resolution: 'Решение',
  scheduled_date: 'Новая дата',
  time_slot: 'Новый интервал',
  previous_assignee: 'Предыдущий исполнитель',
  new_assignee: 'Новый исполнитель',
  quantity: 'Количество',
  weight: 'Вес',
  area: 'Площадь',
  nominal: 'Номинал',
  price: 'Цена',
  old_price: 'Предыдущая цена',
  new_price: 'Новая цена',
  subtotal: 'Сумма',
  amount: 'Сумма',
  discount: 'Скидка',
  discount_amount: 'Скидка',
  final_amount: 'Итого',
  prepayment: 'Предоплата',
  remaining_amount: 'Остаток',
  tag: 'Тег',
  transaction_id: 'Финансовая операция',
  transaction_type: 'Тип операции',
  wallet_scope: 'Кошелек',
  payment_status: 'Оплата',
  payment_method: 'Способ оплаты',
  changed_fields: 'Измененные поля',
  floors_count: 'Количество этажей',
  distance_km: 'Расстояние, км',
  price_coefficient: 'Коэффициент цены',
  price_coefficient_b2c: 'Коэффициент цены (физ. лица)',
  price_coefficient_b2b: 'Коэффициент цены (юр. лица)',
  priority: 'Срочность',
  source: 'Источник',
  destination: 'Получатель',
  notification_type: 'Тип уведомления',
  dispatcher_priority: 'Приоритет',
  dispatcher_call_required_stage: 'Признак созвона',
  invoice_id: 'Счет',
  invoice_number: 'Номер счета',
  invoice_date: 'Дата счета',
  invoice_delivery_method: 'Способ передачи счета',
  invoice_email: 'Email для счета',
  invoice_prepared_at: 'Счет подготовлен',
  act_id: 'Акт',
  act_number: 'Номер акта',
  photo_id: 'Фотография',
  file_name: 'Имя файла',
  revision_id: 'Повторная обработка',
  revision_number: 'Номер повторной обработки',
  rework_id: 'Повторная обработка',
  pickup_date: 'Дата забора',
  pickup_time_slot: 'Время забора',
  pickup_address_id: 'Адрес забора',
  pickup_address_text: 'Адрес забора',
  pickup_time: 'Время забора',
  return_date: 'Дата возврата',
  return_time: 'Время возврата',
  return_delivery_type: 'Способ возврата',
  delivery_date: 'Дата возврата',
  delivery_time_slot: 'Время возврата',
  delivery_address_text: 'Адрес возврата',
  delivery_address_id: 'Адрес возврата',
  date_from: 'Период с',
  date_to: 'Период по',
  target_date: 'Дата документа',
  orders_count: 'Заказов в документе',
  risk_types: 'Типы рисков',
  stages: 'Контролируемые этапы',
  stale_after_hours: 'Без движения, часов',
  order_age_days: 'Возраст заказа, дней',
  revision_age_days: 'Возраст повтора, дней',
  created_at: 'Создано',
  created_date: 'Создано',
  updated_at: 'Изменено',
  completed_at: 'Завершено',
  effective_from: 'Действует с',
  effective_to: 'Действует до',
  last_activity: 'Последняя активность',
  last_activity_at: 'Последняя активность',
  last_client_version: 'Версия приложения',
  client_version_checked_at: 'Версия проверена',
  affected_users: 'Затронуто пользователей',
  unassigned_orders: 'Снято заказов',
  unassigned_tasks: 'Снято поручений',
  token_version: 'Версия сеанса',
};

const normalizeLookup = (value) => String(value ?? '').trim().toLowerCase();

export const getActivityFieldLabel = (key) => {
  const normalized = normalizeLookup(key);
  return ACTIVITY_FIELD_LABELS[normalized]
    || ACTIVITY_VALUE_LABELS[normalized]
    || 'Дополнительные данные';
};

export const translateActivityString = (value) => {
  const text = String(value ?? '').trim();
  if (!text) return '';

  const exactMatch = ACTIVITY_VALUE_LABELS[normalizeLookup(text)];
  if (exactMatch) return exactMatch;

  const menuLabel = ACTIVITY_MENU_LABELS[normalizeLookup(text)];
  if (menuLabel) return menuLabel;

  if (text.includes(',')) {
    return text
      .split(',')
      .map((part) => translateActivityString(part))
      .join(', ');
  }

  return text;
};

export const localizeActivityData = (value) => {
  if (Array.isArray(value)) {
    return value.map((item) => localizeActivityData(item));
  }
  if (value && typeof value === 'object') {
    return Object.entries(value).reduce((result, [key, nestedValue]) => {
      const baseLabel = getActivityFieldLabel(key);
      let label = baseLabel;
      let duplicateNumber = 2;
      while (Object.prototype.hasOwnProperty.call(result, label)) {
        label = `${baseLabel} (${duplicateNumber})`;
        duplicateNumber += 1;
      }
      result[label] = localizeActivityData(nestedValue);
      return result;
    }, {});
  }
  if (typeof value === 'boolean') return value ? 'Да' : 'Нет';
  if (typeof value === 'string') return translateActivityString(value);
  return value;
};

export const stringifyLocalizedActivityData = (value) => {
  if (value === null || value === undefined) return '';
  try {
    return JSON.stringify(localizeActivityData(value), null, 2);
  } catch (error) {
    return translateActivityString(value);
  }
};
